import QualifiPage from "@/pages/QualifiPage";
import { QUALIFI_AESTHETICS } from "@/lib/qualifi";

export default function QualifiAesthetics() {
  return (
    <QualifiPage
      overline="Regulated Qualifications"
      titleLines={[
        <span key="1" className="text-white">Qualifi</span>,
        <span key="2" className="text-gold">Aesthetics.</span>,
      ]}
      intro="Ofqual-regulated aesthetics qualifications from Level 3 through Level 7, delivered by experienced Advanced Aesthetics Practitioners, Educators and Assessors who continue to work within clinical practice. Every programme combines evidence-based theory with practical, hands-on clinical training in small class sizes."
      qualifications={QUALIFI_AESTHETICS}
    />
  );
}
